<template>
  <div class="modal-overlay fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm" @click="$emit('cancel')">
    <div class="modal-content exit-modal bg-white rounded-2xl shadow-2xl p-6 md:p-8 max-w-md mx-4" @click.stop>
      <!-- Warning Icon -->
      <div class="modal-icon warning flex items-center justify-center mb-4">
        <div class="icon-circle w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center">
          <i class="fas fa-exclamation-triangle text-4xl text-amber-600"></i>
        </div>
      </div>

      <!-- Title -->
      <h3 class="modal-title text-2xl md:text-3xl font-bold text-center text-gray-800 mb-4">
        Exit Quiz?
      </h3>

      <!-- Message -->
      <p class="modal-message text-center text-gray-600 text-base md:text-lg mb-6 leading-relaxed">
        Are you sure you want to quit? <strong class="text-red-600">Your progress won't be saved</strong>
        and you'll have to start over.
      </p>

      <!-- Actions -->
      <div class="modal-actions flex flex-col md:flex-row gap-3 md:gap-4">
        <button
          @click="$emit('cancel')"
          class="modal-btn secondary flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-3 px-6 rounded-xl font-bold text-base md:text-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          <i class="fas fa-times"></i>
          Stay
        </button>
        <button
          @click="$emit('confirm')"
          class="modal-btn danger flex-1 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white py-3 px-6 rounded-xl font-bold text-base md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
        >
          <i class="fas fa-sign-out-alt"></i>
          Exit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExitModal',
  emits: ['confirm', 'cancel']
}
</script>

<style scoped>
/* Icon pulse animation */
.icon-circle {
  animation: warning-pulse 2s ease-in-out infinite;
}

@keyframes warning-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0);
  }
}

/* Button animations */
.modal-btn {
  transition: all 0.3s ease;
}

.modal-btn:hover {
  transform: translateY(-2px);
}

.modal-btn:active {
  transform: translateY(0) scale(0.98);
}

/* Modal entrance animation */
.exit-modal {
  animation: modal-enter 0.3s ease-out;
}

@keyframes modal-enter {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
